import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { UmbracoGridElement } from 'src/layout/grid/models/umbraco-grid-element.interface';
import { GeneralElementSettings, SettingsSetterDirective } from '../../models/general-element-settings';


interface UspSettings extends GeneralElementSettings {
    gap: string;
    contentWidth: string;
}


@Component({
    selector: 'app-usp-bulk-element',
    templateUrl: './usp-bulk.component.html',
    styleUrls: ['./usp-bulk.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UspBulkElementComponent extends SettingsSetterDirective implements OnInit {
    @HostBinding('style.--gap')
    gap: string;

    @HostBinding('style.--inner-content-width')
    contentWidth: string;

    @Input()
    declare settings: UspSettings;

    @Input()
    layout?: { layout: UmbracoGridElement[] };

    ngOnInit() {
        super.ngOnInit();
        this.gap = this.settings.gap;
        this.gap = isNaN(+this.gap) || +this.gap === 0 ? this.gap : this.gap + 'px';
        this.contentWidth = this.settings.contentWidth;
        this.contentWidth =  isNaN(+this.contentWidth) || +this.contentWidth === 0 ? this.contentWidth : this.contentWidth + 'px';
        // this.maxWidth = null;
    }
}
